import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import FormField from "../../../utils/FormField";
import { getOrderDetails } from "../../../redux/actions/order_actions.js";
import { getUser, updateUser, getProvinces, getDistricts, getWards, loginUser } from "../../../redux/actions/user_actions";
import { getCategories } from "../../../redux/actions/products_actions";
import { update, generateData, ifFormValid } from "../../../utils/FormAction";
import { Link, withRouter } from "react-router-dom";
import dateFormat from 'dateformat';
import IndexHeader from "components/Headers/IndexHeader.js";
import { HOST_URL} from "../../../utils/misc.js";
import CardBlockOrder from "../../../components/CardBlockOrder/CardBlockOrder";
import Swal from 'sweetalert2';
import Select from 'react-select';
import {
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Row,
    Col, 
    Button,
    Card,
    Form,
} from "reactstrap";
import NProgress from 'nprogress';

const Profile = (props) => {      
    // User Info
    let userInfo = JSON.parse(localStorage.getItem("user")) 

    // State without value
    const [province, setProvince] = useState(userInfo.provinceId)
    const [district, setDistrict] = useState(userInfo.districtId)
    const [ward, setWard] = useState(userInfo.wardId)
    const [category, setCategory] = useState(userInfo.category)
    const [provinces, setProvinces] = useState([])
    const [districts, setDistricts] = useState([])
    const [wards, setWards] = useState([])  
    const state = {
        formError: false,
        formSuccess: "",
        formData: {
            customerName: {
                element: "input",
                value: "",
                config: {
                    name: "customer_name_input",
                    type: "text",
                    placeholder: "Họ tên...",
                },
                validation: {
                    required: true,
                },
                valid: false,
                touched: false,
                validationMessage: "",
            },
            birthDate: {
                element: "input",
                value: "",
                config: {
                    name: "birthday_input",
                    type: "date",
                    placeholder: "Ngày sinh...",
                },
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                validationMessage: "",
            },
            address: {
                element: "input",
                value: "",
                config: {
                    name: "address_input",
                    type: "text",
                    placeholder: "Địa chỉ...",
                },
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                validationMessage: "",
            },
            province: {
                element: "input",
                value: "",
                config: {
                    name: "province_input",
                    type: "text",
                    placeholder: "Tỉnh thành",
                },
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                validationMessage: "",
            },
            district: {
                element: "input",
                value: "",
                config: {
                    name: "district_input",
                    type: "text",
                    placeholder: "Quận/Huyện",
                },
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                validationMessage: "",
            },
            ward: {
                element: "input",
                value: "",
                config: {
                    name: "ward_input",
                    type: "text",
                    placeholder: "Phường/Xã",
                },
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                validationMessage: "",
            },
            email: {
                element: "input",
                value: "",
                config: {
                    name: "email_input",
                    type: "email",
                    placeholder: "Email...",
                    readonly: ""
                },
                validation: {
                    required: false,
                    email: true,
                },
                valid: false,
                touched: false,
                validationMessage: "",
            },
            homePhone: {
                element: "input",
                value: "",
                config: {
                    name: "home_phone_input",
                    type: "number",
                    placeholder: "Số điện thoại...",
                    readonly: ""
                },
                validation: {
                    required: false
                },
                valid: false,
                touched: false,
                validationMessage: "",
            },
            password: {
                element: "input",
                value: "",
                config: {
                    name: "password_input",
                    type: "password",
                    placeholder: "Xác nhận mật khẩu...",
                },
                validation: {
                    required: true,
                },
                valid: false,
                touched: false,
                validationMessage: "",
            },
        },
    }


    const [input, setInput] = useState(state);

    useEffect(() => {
        NProgress.start()
        // Scroll To Top
        window.scrollTo(0, 0)
        
        props.dispatch(getProvinces())
        props.dispatch(getDistricts(userInfo.provinceId))
        props.dispatch(getWards(userInfo.districtId))
        props.dispatch(getCategories())
        props.dispatch(getOrderDetails())
        props.dispatch(getUser(userInfo.accountId)).then(res => {
            if(res.payload) {
                if(res.payload.user != undefined){
                    // Set value for state
                    let user = res.payload.user    
                    let newFormData = {
                        customerName: {
                            element: "input",
                            value: user.customerName,
                            config: {
                                name: "customer_name_input",
                                type: "text",
                                placeholder: "Họ tên...",
                            },
                            validation: {
                                required: true,
                            },
                            valid: false,
                            touched: false,
                            validationMessage: "",
                        },
                        birthDate: {
                            element: "input",
                            value: dateFormat(user.birthDate, "yyyy-mm-dd"),
                            config: {
                                name: "birthday_input",
                                type: "date",
                                placeholder: "Ngày sinh...",
                            },
                            validation: {
                                required: true
                            },
                            valid: false,
                            touched: false,
                            validationMessage: "",
                        },
                        address: {
                            element: "input",
                            value: user.address,
                            config: {
                                name: "address_input",
                                type: "text",
                                placeholder: "Địa chỉ...",
                            },
                            validation: {
                                required: true
                            },
                            valid: false,
                            touched: false,
                            validationMessage: "",
                        },
                        email: {
                            element: "input",
                            value: user.userName,
                            config: {
                                name: "email_input",
                                type: "email",
                                placeholder: "Email...",
                                readonly: ""
                            },
                            validation: {
                                required: false,
                                email: true,
                            },
                            valid: false,
                            touched: false,
                            validationMessage: "",
                        },
                        homePhone: {
                            element: "input",
                            value: user.homePhone,
                            config: {
                                name: "home_phone_input",
                                type: "number",
                                placeholder: "Số điện thoại...",
                                readonly: ""
                            },
                            validation: { 
                                required: false
                            },
                            valid: false,
                            touched: false,
                            validationMessage: "",
                        },
                        password: {
                            element: "input",
                            value: "",
                            config: {
                                name: "password_input",
                                type: "password",
                                placeholder: "Mật khẩu...",
                            },
                            validation: {
                                required: true,
                            },
                            valid: false,
                            touched: false,
                            validationMessage: "",
                        },           
                    };            
        
                    setInput((preState) => ({
                        ...preState,
                        formData : newFormData
                    }))    
                }
            } 
            else {
                localStorage.removeItem("user")
                props.history.push("/login")
            }           
        })
    }, [])
    
    const updateForm = async (element) => {
        const newFormData = update(element, input.formData, "update");
        const newFormData_Input = {
            formError: false,
            formData: newFormData,
        };
        await setInput(newFormData_Input);
    };
    
    const submitForm = async (event) => {
        event.preventDefault();    
        let dataToSubmit = generateData(input.formData, "update");
        if(dataToSubmit) {
            dataToSubmit.provinceId = province
            dataToSubmit.districtId = district
            dataToSubmit.wardId = ward
            dataToSubmit.categoryId = category
        }
        let formIsValid = ifFormValid(input.formData, "update");
        // console.log(dataToSubmit) 

        // Check none data
        if(dataToSubmit.password == "" || dataToSubmit.fullName == "" || dataToSubmit.address == "" || dataToSubmit.birthDate == ""){
            return(
                Swal.fire({
                title: 'Vui lòng điền đủ thông tin',
                text: '',
                icon: 'warning',
                confirmButtonText: 'Đóng',
                confirmButtonColor: '#000000',
                }) 
            )
        }
        else {
            Swal.fire({
                title: 'Chú ý',
                text: "Hãy đảm bảo rằng thông tin của bạn đã chính xác?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#000000',
                confirmButtonText: 'Đồng ý',
                cancelButtonColor: '#999897',
                cancelButtonText: 'Đóng'
                }).then((result) => {
                if (result.value) {
                    let user = {
                        email: userInfo.userName, 
                        password: dataToSubmit.password
                    }
                    props.dispatch(loginUser(user)).then(res => {
                        if(res.payload.user.success) {
                            props.dispatch(updateUser(dataToSubmit)).then((res) => {
                                if(res.payload) {
                                    console.log(res.payload)
                                    if(res.payload.result.success) {
                                        Swal.fire({
                                            title: 'Cập nhật thông tin thành công!',
                                            text: '',
                                            icon: 'success',
                                            confirmButtonText: 'Đóng',
                                            confirmButtonColor: '#000000',
                                        })
                                        props.dispatch(loginUser(user))
                                    }
                                    else{
                                        Swal.fire({
                                            title: 'Cập nhật thông tin thất bại!',
                                            text: '',
                                            icon: 'warning',
                                            confirmButtonText: 'Đóng',
                                            confirmButtonColor: '#000000',
                                        })
                                    }
                                }
                                else {
                                    Swal.fire({
                                        title: 'Phiên đăng nhập đã hết hạn!',
                                        text: 'Vui lòng đăng nhập lại',
                                        icon: 'warning',
                                        confirmButtonText: 'Đóng',
                                        confirmButtonColor: '#000000',
                                        }).then((ok) => {
                                            if(ok) {
                                                props.history.push("/login")
                                                localStorage.removeItem("user")
                                            }
                                        })  
                                }
                            })
                        }
                        else {
                            Swal.fire({
                                title: 'Mật khẩu không chính xác!',
                                text: 'Vui lòng đăng nhập lại',
                                icon: 'warning',
                                confirmButtonText: 'Đóng',
                                confirmButtonColor: '#000000',
                            })
                        }
                    })
                }
                })
        }
    };

    const handleChangeProvince = (selectedProvince) => {
        if(selectedProvince) {
            setProvince(selectedProvince.value)
            props.dispatch(getDistricts(selectedProvince.value)).then(res => {
                if(res.payload) {
                    if(res.payload.districts) {
                        setDistricts(res.payload.districts)
                    }
                } 
            })
        }
    }
    
    const handleChangeDistrict = (selectedDistrict) => {
        if(selectedDistrict) {
            setDistrict(selectedDistrict.value)
            props.dispatch(getWards(selectedDistrict.value)).then(res => {
                if(res.payload) {
                    if(res.payload.wards) {
                        setWards(res.payload.wards)
                    }
                } 
            })
        }
    } 

    const handleChangeWard = (selectedWard) => {
        if(selectedWard) {
            setWard(selectedWard.value)
        }
    } 

    const handleChangeCategory = (selectedCategory) => {
        if(selectedCategory) {
            setCategory(selectedCategory.value)
        }
    } 
    
    const renderUserInfo = () => {
        // console.log(props.product)
        if(props.user.userLogin && props.user.userLogin.user && props.user.provinces && props.user.provinces.provinces && props.user.districts && props.user.districts.districts
            && props.user.wards && props.user.wards.wards && props.products.categories && props.products.categories.categories) {
            NProgress.done()
            return(
                <Container>
                    <Row>
                        <Col className="mx-auto formUser" lg="10" md="8">
                        <Card className="card-register" style={{ minWidth:300, background:`linear-gradient(${props.templates.templates.templateProperties.background_form_profile_first}, ${props.templates.templates.templateProperties.background_form_profile_second})` }}>
                            <Form className="register-form" onSubmit={(event) => submitForm(event)}>
                            <label>Email</label>
                                <div>
                                <FormField
                                    id={"email"}
                                    formData={input.formData.email}
                                    change={(element) => updateForm(element)}
                                />
                                </div>
                            <label>Số điện thoại</label>
                                <div>
                                    <FormField
                                        id={"homePhone"}
                                        formData={input.formData.homePhone}
                                        change={(element) => updateForm(element)}
                                    />
                                </div>
                            <label>Họ tên</label>
                                <div>
                                    <FormField
                                    id={"customerName"}
                                    formData={input.formData.customerName}
                                    change={(element) => updateForm(element)}
                                    />
                                </div>
                            <label>Ngày sinh</label>
                                <div style={{ color:"black" }}>
                                    <FormField
                                        id={"birthDate"}
                                        formData={input.formData.birthDate}
                                        change={(element) => updateForm(element)}
                                        />
                                </div>
                            <label>Địa chỉ (nơi giao hàng)</label>
                                <div>
                                    <FormField
                                    id={"address"}
                                    formData={input.formData.address}
                                    change={(element) => updateForm(element)}
                                    />
                                </div>
                            <div className="row mt-1">
                                <div className="col-md-4 col-xs-12 text-dark province">
                                    <Select
                                        defaultValue = {props.user.provinces.provinces.filter(option => option.value == userInfo.provinceId)}
                                        placeholder="Tỉnh thành"
                                        isSearchable
                                        options = {props.user.provinces.provinces}
                                        onChange= {handleChangeProvince} 
                                        noOptionsMessage={() => 'Chưa chọn tỉnh'}
                                        theme = { theme => ({
                                            ...theme,
                                            borderRadius: 5,
                                            colors: {
                                                ...theme.colors,
                                                primary: '#444444',
                                            }
                                        })}
                                    />
                                </div>
                                <div className="col-md-4 col-xs-12 text-dark district">
                                    <Select
                                        defaultValue = {props.user.districts.districts.filter(option => option.value == userInfo.districtId)}
                                        placeholder="Quận/Huyện"
                                        isSearchable
                                        options = {props.user.districts.districts}
                                        onChange = {handleChangeDistrict}
                                        noOptionsMessage={() => 'Chưa chọn quận/huyện'}
                                        theme = { theme => ({
                                            ...theme,
                                            borderRadius: 5,
                                            colors: {
                                                ...theme.colors,
                                                primary: '#444444',
                                            },
                                        })}
                                    />
                                </div>
                                <div className="col-md-4 col-xs-12 text-dark ward">
                                    <Select
                                        defaultValue = {props.user.wards.wards.filter(option => option.value == userInfo.wardId)}
                                        placeholder="Phường/Xã"
                                        isSearchable
                                        options = {props.user.wards.wards}
                                        onChange = {handleChangeWard}
                                        noOptionsMessage={() => 'Chưa chọn phường/xã'}
                                        theme = { theme => ({
                                            ...theme,
                                            borderRadius: 5,
                                            colors: {
                                                ...theme.colors,
                                                primary: '#444444',
                                            },
                                        })}
                                    />
                                </div>
                            </div>
                            <label>Loại sản phẩm quan tâm</label>
                                <div className="text-dark">
                                    <Select
                                        defaultValue = {props.products.categories.categories.filter(option => option.value == userInfo.category)}
                                        placeholder="Loại sản phẩm"
                                        isSearchable
                                        options = {props.products.categories.categories}
                                        onChange = {handleChangeCategory}
                                        noOptionsMessage={() => 'Chưa chọn loại sản phẩm'}
                                        isDisabled
                                        theme = { theme => ({
                                            ...theme,
                                            borderRadius: 5,
                                            colors: {
                                                ...theme.colors,
                                                primary: '#444444',
                                            },
                                            height: 10
                                        })}
                                    />
                                </div>
                            <label>Mật Khẩu</label>
                                <div>
                                    <FormField
                                        id={"password"}
                                        formData={input.formData.password}
                                        change={(element) => updateForm(element)}
                                    />
                                </div>
                            <Button
                                block
                                className="btn-round"
                                color="default"
                                type="button"
                                style={{ marginTop:10 }}
                                onClick={(event) => submitForm(event)}
                                style={{ marginTop:"5%" }}
                            >
                                Cập Nhật
                            </Button>
                            </Form>
                        </Card>
                        </Col>
                    </Row>
                </Container>
            )
        }
        return(
            null
        )        
    }

    // Handle Toggle TabPane
    const [activeTab, setActiveTab] = useState("1");
    const toggle = (tab) => {
      if (activeTab !== tab) {
        setActiveTab(tab);
      }
    }

    return (
        <>
            <IndexHeader title="Thông Tin" imageUrl={HOST_URL + props.templates.templates.templateProperties.image_profilepage} minHeight="500" />
            <div className="profile-content">
                <div className="owner">
                    <div className="avatar">
                        <img
                            alt="..."
                            className="img-circle img-no-padding img-responsive"
                            src={require("assets/img/faces/user.png")}
                            style={{ width:"70%" }}
                        />
                    </div>
                    <div className="name">
                        <h4 className="title">
                            {userInfo.customerName}
                        </h4>
                        <h6 className="text-dark">Thông Tin Tài Khoản</h6>
                    </div>
                </div>
            </div>
            <div className="container-fluid p-0">
                <div className="container">
                    <div className="row" style={{ background:`linear-gradient(${props.templates.templates.templateProperties.background_profile_first}, ${props.templates.templates.templateProperties.background_profile_second})`, margin:"0 auto", marginBottom:"2%", paddingBottom:"2%" }}>
                        <div className="col-md-3" style={{ marginTop:"2%", borderRight:"1px solid lightgrey" }}>
                            <Nav className="nav flex-column" id="tabs" role="tablist">
                                <NavItem className="nav-pills">
                                    <NavLink
                                        className={activeTab === "1" ? "active" : ""}
                                        onClick={() => {
                                        toggle("1");
                                        }}
                                        style={{ cursor:"pointer" }}
                                    >
                                        <b><i className="fa fa-user" aria-hidden="true"></i> Thông tin cá nhân</b>
                                    </NavLink>
                                </NavItem>
                                <NavItem className="nav-pills">
                                    <NavLink
                                        className={activeTab === "2" ? "active" : ""}
                                        onClick={() => {
                                        toggle("2");
                                        }}
                                        style={{ cursor:"pointer" }}
                                    >
                                        <b><i className="fa fa-shopping-cart" aria-hidden="true"></i> Đơn hàng</b>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                        <div className="col-md-9">
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <div>
                                        {renderUserInfo()}
                                    </div>
                                </TabPane>
                                <TabPane tabId="2">
                                    <CardBlockOrder
                                    list={props.order.orderDetails} />
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        order: state.order,
        user: state.user,
        products: state.products,
        templates: state.templates,
    };
};

export default connect(mapStateToProps)(withRouter(Profile));
